import React from 'react';
import { QdsButton } from '@quartzds/core-react';


type Props = {
    className?: string;
    href?: string;
    text: string;
    onClick?: (event: React.MouseEvent) => void;
};

export const CustomLinkBookIcon: React.FC<Props> = ({
    className,
    children,
    href,
    text,
    ...otherProps
}) => (
  <QdsButton
    className={className}
    size='standard' 
    importance='subdued'
    href={href}
    iconName='book-closed'
    text={text}
    {...otherProps}
  />
);
